var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMoreItems),expression:"loadMoreItems"}],ref:"container",attrs:{"infinite-scroll-disabled":!_vm.hasMoreData || !_vm.isVisible,"infinite-scroll-distance":10}},[_vm._t("default",null,{"items":_vm.visibleItems})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }